import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { setEditorWidget, opentTab } from '../actions';
import config from 'cfg';
import { withRouter } from 'react-router';
import { WidgetPreviewStatic } from '../components/NetflixGallery';
import FlatButton from 'material-ui/FlatButton/FlatButton';
import styled from 'styled-components';
import IconNext from 'material-ui/svg-icons/navigation/chevron-right';
import _ from 'lodash';
import Controls from './controls/Controls';
import Header from './controls/Header';

const LayoutSelection = styled.div`
    margin: 6px 0;
    position: relative;
    width: 100%;

    cursor: pointer;
    &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1004;
        transition: all 0.3s linear;
        pointer-events: none;
    }
    &:hover:after {
        background: rgba(0, 0, 0, 0);
    }
`;

const LayoutPreview = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    background: rgba(0, 0, 0, 0.1);

    .img-container {
        display: inline-block;
        overflow: hidden;
        position: relative;
    }
    .demo {
        position: absolute;
        top: 12px;
        right: -23px;
        background: red;
        z-index: 1001;
        padding: 3px 25px;
        color: #fff;
        transform: rotate(45deg);
    }
`;

const Layouts = compose(
    withRouter,
    connect(
        ({ editor, user }, props) => {
            return {
                user,
                widget: editor.widget,
                widgetId: editor.widgetId,
                template: editor.template,
            };
        },
        { setEditorWidget, opentTab },
    ),
    lifecycle({
        componentWillReceiveProps() {},
    }),
)(({ widgetId, widget, user, template, opentTab }) => {
    const lang = _.get(user, 'props.lang', 'da');
    if (!widgetId) return <div />;

    const demoURL = `${config.widgets.url}/widget/${user.client}/${
        user.username
    }/default/${widgetId}/demo-image?lang=${lang}&template=${template}`;

    return (
        <LayoutPreview>
            <Header label="Step 1." text="Select layout" />
            <div
                style={{
                    width: '100%',
                    flexGrow: 1,
                    overflow: 'hidden',
                    textAlign: 'center',
                    padding: 15,
                    boxSizing: 'content-box',
                }}
            >
                <img
                    alt=""
                    key={`${widgetId}_${template}`}
                    style={{
                        flexGrow: 1,
                        height: '100%',
                        widows: '100%',
                        maxHeight: 500,
                        objectFit: 'contain',
                        display: 'inline-block',
                    }}
                    src={demoURL}
                />
            </div>
            <div style={{ textAlign: 'right', background: 'rgba(0,0,0,0.1)' }}>
                <FlatButton
                    label="Step 2: Select data"
                    // icon={<IconNext />}
                    primary
                    style={{ height: 48, color: '#fff' }}
                    backgroundColor="#008c9c"
                    color="#fff"
                    hoverColor="#007c8a"
                    labelPosition="before"
                    icon={<IconNext />}
                    onClick={() => {
                        opentTab('data');
                    }}
                />
            </div>
        </LayoutPreview>
    );
});

const LayoutsImagesList = compose(
    connect(
        ({ editor }, props) => {
            const widgetIds = (editor.widgets.all && editor.widgets.all.map(w => w.id)) || [];
            const layoutsSpec = editor.widget && editor.widget.layoutsSpec.filter(w => widgetIds.includes(w.id));

            return {
                layoutsSpec: layoutsSpec || [],
                widgetId: editor.widgetId,
            };
        },
        { setEditorWidget },
    ),
    lifecycle({
        componentWillReceiveProps() {},
    }),
)(({ layoutsSpec, widgetId, template, setEditorWidget }) => (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', margin: 15 }}>
        {layoutsSpec.map(layout => {
            return (
                <LayoutSelection
                    key={layout.id}
                    onClick={e => {
                        setEditorWidget(layout.id);
                    }}
                >
                    <div
                        style={{
                            width: '100%',
                        }}
                    >
                        <WidgetPreviewStatic
                            style={{
                                alignSelf: 'stretch',
                                borderWidth: 5,
                                borderStyle: 'solid',
                                borderColor: 'transparent',
                                ...(layout.id === widgetId ? { borderColor: '#fff' } : {}),
                            }}
                            widgetId={layout.id}
                            template={template}
                            name={layout.name}
                            demo
                        />
                    </div>
                    {layout.id === widgetId && (
                        <p
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: 20,
                                right: 20,
                                zIndex: 10000,
                                textAlign: 'center',
                                background: '#008c9d',
                                borderRadius: '15px',
                                padding: '5px 15px',
                            }}
                        >
                            SELECTED LAYOUT
                        </p>
                    )}
                </LayoutSelection>
            );
        })}
    </div>
));

const LayoutsList = compose(
    connect(
        ({ editor }, props) => {
            return {
                layouts: editor.widget && editor.widget.layouts,
                widgetId: editor.widgetId,
            };
        },
        { setEditorWidget },
    ),
    lifecycle({
        componentWillReceiveProps() {},
    }),
)(({ layouts = [], widgetId, template, widgetProps = {}, setEditorWidget }) => (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
        {[widgetId, ...(layouts || [])].map(wid => (
            <FlatButton
                key={wid}
                primary={widgetId === wid}
                label={wid}
                onClick={() => {
                    setEditorWidget(wid);
                }}
            />
        ))}
    </div>
));

export { LayoutsList, LayoutsImagesList };
export default Layouts;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/WidgetLayouts.js
 **/